import { defineComponent as _defineComponent } from 'vue'
import { unref as _unref, createElementVNode as _createElementVNode, toDisplayString as _toDisplayString, resolveComponent as _resolveComponent, createVNode as _createVNode, openBlock as _openBlock, createElementBlock as _createElementBlock, createCommentVNode as _createCommentVNode, withModifiers as _withModifiers, renderSlot as _renderSlot, Fragment as _Fragment } from "vue"

const _hoisted_1 = ["id"]
const _hoisted_2 = { class: "row" }
const _hoisted_3 = { class: "form-check col-10 ms-0 small" }
const _hoisted_4 = ["id", "value", "checked"]
const _hoisted_5 = { class: "form-check-label" }
const _hoisted_6 = ["onClick", "data-target"]
const _hoisted_7 = { key: 0 }
const _hoisted_8 = { key: 1 }
const _hoisted_9 = ["id"]

import { computed, ref, Ref } from "vue";
import { Tema } from "@/types/legotyper";


export default /*#__PURE__*/_defineComponent({
  __name: 'TemaElement',
  props: {
    tema: null,
    checked: { type: Boolean },
    aktiv: { type: Boolean }
  },
  emits: ["check"],
  setup(__props: any, { emit }: { emit: ({
  (e: "check", value: string): void;
}), expose: any, slots: any, attrs: any }) {

const props = __props as {
  tema: Tema;
  checked: boolean;
  aktiv?: boolean;
}





const visBlok: Ref<boolean | undefined> = ref(undefined);
const temaNavn = computed(() => {
  return props.tema.navn.toLocaleLowerCase().replace(/ /g, "-");
});
const temaId = computed(() => {
  return "#" + temaNavn.value;
});

function toggle() {
  if (visBlok.value == undefined) {
    if (props.aktiv == undefined) {
      visBlok.value = false;
    } else {
      visBlok.value = props.aktiv;
    }
  }
  visBlok.value = !visBlok.value;
}

return (_ctx: any,_cache: any) => {
  const _component_font_awesome_icon = _resolveComponent("font-awesome-icon")!

  return (_openBlock(), _createElementBlock(_Fragment, null, [
    _createElementVNode("div", {
      class: "tema-element",
      id: _unref(temaNavn)
    }, [
      _createElementVNode("div", _hoisted_2, [
        _createElementVNode("label", _hoisted_3, [
          _createElementVNode("input", {
            class: "form-check-input",
            type: "checkbox",
            id: __props.tema.id,
            value: __props.tema.navn,
            checked: props.checked,
            onClick: _cache[0] || (_cache[0] = ($event: any) => (_ctx.$emit('check', __props.tema.navn)))
          }, null, 8, _hoisted_4),
          _createElementVNode("span", _hoisted_5, _toDisplayString(__props.tema.navn), 1)
        ]),
        _createElementVNode("div", {
          class: "col-2",
          role: "button",
          onClick: _withModifiers(toggle, ["prevent"]),
          "data-toggle": "collapse",
          "data-target": _unref(temaId)
        }, [
          (visBlok.value)
            ? (_openBlock(), _createElementBlock("div", _hoisted_7, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fas', 'minus'],
                  size: "xs"
                })
              ]))
            : (_openBlock(), _createElementBlock("div", _hoisted_8, [
                _createVNode(_component_font_awesome_icon, {
                  icon: ['fas', 'plus'],
                  size: "xs"
                })
              ]))
        ], 8, _hoisted_6)
      ])
    ], 8, _hoisted_1),
    (visBlok.value)
      ? (_openBlock(), _createElementBlock("div", {
          key: 0,
          class: "row",
          id: _unref(temaId)
        }, [
          _renderSlot(_ctx.$slots, "default")
        ], 8, _hoisted_9))
      : _createCommentVNode("", true)
  ], 64))
}
}

})